// extracted by mini-css-extract-plugin
export default {"Toggle":"SwitchToggle_Toggle__cCNL5","Active":"SwitchToggle_Active__X1mnN","Slider":"SwitchToggle_Slider__E5YxB","VariantSecondary":"SwitchToggle_VariantSecondary__wwbxo"};